"use strict";
/**
 * Enriched Types
 *
 * Types for data that has been enriched with additional information
 * from related records (e.g., patterns enriched with author info)
 */
Object.defineProperty(exports, "__esModule", { value: true });
